module.exports = __webpack_public_path__ + "img/q2.55b39572.jpg";